import cookie from 'cookie';

import {DEFAULT_THEME, HIGH_CONTRAST_THEME} from '.';

const PREFERS_HIGH_CONTRAST_QUERY = '(prefers-contrast: more)';
const COOKIE_KEY = 'scratchtheme';

// Dark mode isn't enabled yet
const isValidTheme = theme => [DEFAULT_THEME, HIGH_CONTRAST_THEME].includes(theme);

const systemPreferencesTheme = () => {
    return DEFAULT_THEME;
};

const detectTheme = () => {
    // Force the classic Scratch palette in this build.
    return DEFAULT_THEME;
};

const persistTheme = theme => {
    const safeTheme = isValidTheme(theme) ? theme : DEFAULT_THEME;
    const expires = new Date(new Date().setYear(new Date().getFullYear() + 1)).toUTCString();
    document.cookie = `${COOKIE_KEY}=${safeTheme};expires=${expires};path=/`;
};

export {
    detectTheme,
    persistTheme
};
